import { FC, useEffect, useState } from 'react';
import { Pretest } from '../../components/modules/Pretest';
import MainTest from '../../components/modules/MainTest';
import { Layout } from '../../components/shared/Layout';
import { HomeSwitchCases } from './types';
import { Beforeunload } from 'react-beforeunload';
import { getExternalUrls } from 'redux/externalurls/thunks';
import { getPretestQuestions } from 'redux/pretest/thunks';
import { useAppDispatch } from 'redux/store';

const HomePage: FC = () => {
  const [route, setRoute] = useState(HomeSwitchCases.pretest);

  const routeTo = (name: HomeSwitchCases) => {
    setRoute(name);
  };

  const dispatch = useAppDispatch();

  useEffect(() => {
    void dispatch(getExternalUrls());
    void dispatch(getPretestQuestions());
  }, []);

  const switchView = () => {
    switch (route) {
      case HomeSwitchCases.pretest:
        return <Pretest onRouteTo={() => routeTo(HomeSwitchCases.test)} />;
      case HomeSwitchCases.test:
        return (
          <Beforeunload onBeforeunload={() => ''}>
            <MainTest />
          </Beforeunload>
        );
      default:
        return null;
    }
  };

  return <Layout>{switchView()}</Layout>;
};

export default HomePage;
